/*
	Die Konfiguration kann über den Parameter "config" an der ReservaApp definiert werden.
	Die MiniEngine schleift diesen Parameter sauber durch.

	Beispiel:
	window.reservaApp = new ReservaApp({
		...
		config: {
			"PeopleStructure.ShowRoomTypes": false,
		}
	});

	Abruf in Template:
		<% registry(key) %>

	Abruf in JS-Code:
		let Registry = require('registry');
		let value = Registry.get(key)
*/

var client = window.Tramino.client;

/* PeopleStructure.js */
let defaults = {
	/* Soll die Auswahl für mehrere Unterkünfte aktiviert werden? */
	"PeopleStructure.ShowMultiRooms": false, /* temporär deaktiviert wegen Reserva API Bug */

	/* Sollen die Raumtypen bei der Personenauswahl angezeigt werden? */
	"PeopleStructure.ShowRoomTypes": true,

	/* Kürzere Personenangabe im PeopleSelect */
	"PeopleSelect.ShortText": false,

	/* Kürzere Datumsangaben in DateTime.textPeriod? */
	"DateTime.ShortTextPeriod": false,

	/* Reserva DatePicker: Option "Flexibel" */
	"DatePicker.EnableFlexible": false,

	/* Nachricht in der Engine */
	"Engine.NoResultTitle": "Keine Gastgeber gefunden",
	"Engine.NoResultMessage": "",

	/* Engine: Suchfilter nach Kategorien ermöglichen */
	"Engine.CategorySearch": false,

	/* MiniEngine: Alternative TimeTable aktivieren */
	"MiniEngine.UseTimeTableYear": true,

	/* result-template: Basis-URL für Partner */
	"PartnerBase": window.Tramino.lang === "de" ? "/partner/" : `/${window.Tramino.lang}/partner/`,

	/* Limit fürs zusammenklappen von Tag-Gruppen (engine/SidebarTemplate.html) */
	"CollapseTagGroupsTreshhold": 5,

	/* Kundenspezifische Einstellungen */
	"Customer": {
		Alpentraum: (client == 3254 || client ==  3200 || client == 10494 || client == 3255),
		Bergwelt: (client == 1301),
		Wertach: client == 9350,
		Scheidegg: client == 720,
		Oberstdorf: client == 100,
		Montana: client == 1525,
	},
}

if ( defaults.Customer.Alpentraum ) defaults["Engine.CategorySearch"] = true;
if ( defaults.Customer.Wertach || defaults.Customer.Scheidegg ) defaults["PeopleStructure.ShowMultiRooms"] = true;
if ( defaults.Customer.Wertach ) defaults["CollapseTagGroupsTreshhold"] = 99;
if ( defaults.Customer.Oberstdorf ) defaults["MiniEngine.UseTimeTableYear"] = false;

module.exports = defaults;



// WEBPACK FOOTER //
// ./reserva-config.js